import React, { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import fp from 'lodash/fp';

import { cn, ClassName } from 'Modules/ui';
import { ContentType } from 'Modules/core/i18n';

import { InputField, InputFieldProps, PasswordField } from '../FormField';
import styles from './index.module.scss';


export const withStyledClasses = (field, isRequired, valid, value) => {
    const { classNames, ...other } = field || {};
    return {
        classNames: {
            ...classNames,
            label: styles.label,
            container: cn(styles.formField, value && styles.topLabel, fp.get('container', classNames)),
            isFocused: styles.topLabel,
            isRequired: isRequired && styles.isRequired,
            error: styles.error,
            wrapper: styles.inputWrapper,
            hasError: styles.hasError,
        },
        ...other,
    };
};

export interface StyledInputFieldProps extends
    InputFieldProps,
    FieldRenderProps<string>,
    ClassName
{
    error?: ContentType;
}

export const StyledInputField: FC<StyledInputFieldProps> = ({
    className, field, meta, isRequired, input, error, ...props
}) => (
    <InputField
        className={cn(styles.input, className)}
        field={withStyledClasses(field, isRequired, meta.valid, input.value)}
        meta={{
            ...meta,
            error: error || meta.error,
            touched: meta.touched || !!error,
        }}
        input={input}
        {...props}
    />
);

export const StyledPasswordField: FC<StyledInputFieldProps> = ({
    className, field, meta, isRequired, input, error, ...props
}) => (
    <PasswordField
        className={cn(styles.input, className)}
        field={withStyledClasses(field, isRequired, meta.valid, input.value)}
        meta={{
            ...meta,
            error: error || meta.error,
        }}
        input={input}
        {...props}
    />
);
